import { DataState } from "Models/Common/DataState";
import { PagedResult } from "Models/Common/PagedResult";
import { TaskTemplate } from "Models/Tasks/TaskTemplate";
import { TaskTemplateTag } from "Models/Tasks/TaskTemplateTag";
import { Action } from "redux";
import { TaskTemplateFilterState } from "./TaskTemplateFilterState";

export const enum ActionTypes {
    FILTER_UPDATED = "FILTER_UPDATED",
    PAGE_RETRIEVED = "PAGE_RETRIEVED",
    CLEAR_TEMPLATES = "CLEAR_TEMPLATES",
    TASK_TEMPLATE_STATE_CHANGED = "TASK_TEMPLATE_STATE_CHANGED",
    TASK_TEMPLATE_RETRIEVED = "TASK_TEMPLATE_RETRIEVED",
    TASK_TEMPLATE_SAVED = "TASK_TEMPLATE_SAVED",
    TASK_TEMPLATE_DELETED = "TASK_TEMPLATE_DELETED",
    SHOW_VALIDATION_ERRORS = "SHOW_VALIDATION_ERRORS",
    CLEAR_VALIDATION_ERRORS = "CLEAR_VALIDATION_ERRORS",
    ARRANGE_FILTER_UPDATED = "ARRANGE_FILTER_UPDATED",
    ARRANGE_CLEAR_TASK_TEMPLATES = "ARRANGE_CLEAR_TASK_TEMPLATES",
    ARRANGE_RETRIEVING_TASK_TEMPLATES = "ARRANGE_RETRIEVING_TASK_TEMPLATES",
    ARRANGE_RETRIEVED_TASK_TEMPLATES = "ARRANGE_RETRIEVED_TASK_TEMPLATES",
    TASK_TEMPLATE_TAGS_RETRIEVED = "TASK_TEMPLATE_TAGS_RETRIEVED"
}

export interface IFilterUpdatedAction extends Action {
    type: ActionTypes.FILTER_UPDATED;
    filter: TaskTemplateFilterState;
}

export interface IPageRetrievedAction extends Action {
    type: ActionTypes.PAGE_RETRIEVED;
    page: PagedResult<TaskTemplate>;
}

export interface IClearTemplateAction extends Action {
    type: ActionTypes.CLEAR_TEMPLATES;
}

export interface ITaskTemplateStateChangedAction extends Action {
    type: ActionTypes.TASK_TEMPLATE_STATE_CHANGED;
    taskTemplateId?: number;
    newState: DataState;
}

export interface ITaskTemplateRetrievedAction extends Action {
    type: ActionTypes.TASK_TEMPLATE_RETRIEVED;
    taskTemplate: TaskTemplate;
}

export interface ITaskTemplateSavedAction extends Action {
    type: ActionTypes.TASK_TEMPLATE_SAVED;
    taskTemplate: TaskTemplate;
}

export interface ITaskTemplateDeletedAction extends Action {
    type: ActionTypes.TASK_TEMPLATE_DELETED;
    taskTemplateId: number;
}

export interface IShowValidationErrorsAction extends Action {
    type: ActionTypes.SHOW_VALIDATION_ERRORS;
    validationErrors: string[];
    taskTemplateId?: number;
}

export interface IClearValidationErrorsAction extends Action {
    type: ActionTypes.CLEAR_VALIDATION_ERRORS;
    taskTemplateId?: number;
}

export interface IArrangeFilterUpdatedAction extends Action {
    type: ActionTypes.ARRANGE_FILTER_UPDATED;
    filter: TaskTemplateFilterState;
}

export interface IArrangeClearTaskTemplatesAction extends Action {
    type: ActionTypes.ARRANGE_CLEAR_TASK_TEMPLATES;
}

export interface IArrangeRetrievingTaskTemplatesAction extends Action {
    type: ActionTypes.ARRANGE_RETRIEVING_TASK_TEMPLATES;
}

export interface IArrangeRetrievedTaskTemplatesAction extends Action {
    type: ActionTypes.ARRANGE_RETRIEVED_TASK_TEMPLATES;
    arrangeTaskTemplates: TaskTemplate[];
}

export interface ITaskTemplateTagsRetrievedAction extends Action {
    type: ActionTypes.TASK_TEMPLATE_TAGS_RETRIEVED;
    data: TaskTemplateTag[];
}

export type TaskTemplateActions = IFilterUpdatedAction | IPageRetrievedAction | IClearTemplateAction | ITaskTemplateRetrievedAction | ITaskTemplateStateChangedAction | ITaskTemplateSavedAction | ITaskTemplateDeletedAction | IShowValidationErrorsAction | IClearValidationErrorsAction | IArrangeFilterUpdatedAction | IArrangeClearTaskTemplatesAction | IArrangeRetrievingTaskTemplatesAction | IArrangeRetrievedTaskTemplatesAction | ITaskTemplateTagsRetrievedAction;


// WEBPACK FOOTER //
// ./src/Store/TaskTemplates/TaskTemplateActionTypes.ts